import { BancoAgencia } from './banco-agencia.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class BancoAgenciaService {

    constructor(private http: Http) {
    }

    getBancoAgencias(): Observable<BancoAgencia[]> {
        return this.http.get(`${NTECH_API}/banco-agencia`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/banco-agencia/banco-agencia.service.ts